__turbopack_context__.v({
  "annotation_list": "VShYLa_annotation_list",
  "annotation_list__number": "VShYLa_annotation_list__number",
});
